import { render, staticRenderFns } from "./createCdnResource.vue?vue&type=template&id=766e9c35&scoped=true&"
import script from "./createCdnResource.vue?vue&type=script&lang=js&"
export * from "./createCdnResource.vue?vue&type=script&lang=js&"
import style0 from "./createCdnResource.vue?vue&type=style&index=0&id=766e9c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e9c35",
  null
  
)

export default component.exports